// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FjRf","rootNoMargin":"styles_rootNoMargin__2ROY4"};